import { render, staticRenderFns } from "./runPoll.vue?vue&type=template&id=82123ef4&scoped=true&"
import script from "./runPoll.vue?vue&type=script&lang=js&"
export * from "./runPoll.vue?vue&type=script&lang=js&"
import style0 from "./runPoll.vue?vue&type=style&index=0&id=82123ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82123ef4",
  null
  
)

export default component.exports